import { render, staticRenderFns } from "./tussentijdse-toets.vue?vue&type=template&id=bb022956"
import script from "./tussentijdse-toets.vue?vue&type=script&lang=js"
export * from "./tussentijdse-toets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports